import { FilterExternalLabelTypeScope, FilterResourceScope } from 'api/filters';
import { CustomFieldGroup } from 'types/domain';

export const filterQueryKeys = {
    base: (accountId: number) => ['filters', accountId],
    tags: (accountId: number, scope: FilterResourceScope) => [
        ...filterQueryKeys.base(accountId),
        'tags',
        scope,
    ],
    campaigns: (accountId: number) => [...filterQueryKeys.base(accountId), 'campaigns'],
    campaignsWithFilter: (accountId: number, resource: string) => [
        ...filterQueryKeys.campaigns(accountId),
        resource,
    ],
    teams: (accountId: number) => [...filterQueryKeys.base(accountId), 'teams'],
    teamMembers: (accountId: number) => [...filterQueryKeys.base(accountId), 'teamMembers'],
    funds: (accountId: number) => [...filterQueryKeys.base(accountId), 'funds'],
    ticketTypes: (accountId: number) => [...filterQueryKeys.base(accountId), 'ticketTypes'],
    externalLabels: (accountId: number, scope: FilterExternalLabelTypeScope) => [
        ...filterQueryKeys.base(accountId),
        'externalLabels',
        scope,
    ],
    campaignMatches: (accountId: number) => [...filterQueryKeys.base(accountId), 'campaignMatches'],
    customFields: (accountId: number, scope: CustomFieldGroup) => [
        ...filterQueryKeys.base(accountId),
        'customFields',
        scope,
    ],
    widgets: (accountId: number) => [...filterQueryKeys.base(accountId), 'widgets'],
    trackableMessages: (accountId: number) => [
        ...filterQueryKeys.base(accountId),
        'trackableMessages',
    ],
    mailings: (accountId: number) => [...filterQueryKeys.base(accountId), 'mailings'],
};
